import { SVGProps } from 'react'

export const VisaWhite = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="27"
      height="15"
      viewBox="0 0 27 15"
      fill={props.color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13.126 4.80421L11.9623 10.4459H10.5548L11.7186 4.80421H13.126ZM19.0472 8.44714L19.788 6.32856L20.2143 8.44714H19.0472ZM20.6181 10.4459H21.9195L20.7825 4.80421H19.5821C19.3115 4.80421 19.0834 4.96688 18.9825 5.21775L16.8707 10.4459H18.3488L18.6422 9.60337H20.4476L20.6181 10.4459ZM16.944 8.6041C16.9501 7.11516 14.9592 7.03268 14.9725 6.36739C14.9768 6.16525 15.1628 5.94991 15.5693 5.89484C15.7708 5.86794 16.3269 5.84611 16.9573 6.14736L17.2039 4.95051C16.8653 4.8235 16.4296 4.70117 15.8874 4.70117C14.4961 4.70117 13.5173 5.4676 13.5095 6.56597C13.5005 7.3782 14.2086 7.83108 14.741 8.10161C15.2899 8.37811 15.4738 8.55538 15.4711 8.80243C15.4673 9.18095 15.0335 9.34858 14.6294 9.35492C13.9215 9.36634 13.5111 9.15646 13.184 8.99836L12.9285 10.2352C13.2579 10.3915 13.8648 10.5275 14.4932 10.5345C15.9724 10.5345 16.9396 9.77709 16.944 8.6041ZM11.1149 4.80421L8.83447 10.4459H7.34694L6.22466 5.94344C6.15662 5.66656 6.09728 5.5648 5.89037 5.4478C5.55192 5.25721 4.99323 5.07893 4.50195 4.96802L4.53524 4.80421H6.93006C7.2351 4.80421 7.50956 5.01472 7.57942 5.37915L8.17226 8.64407L9.63629 4.80421H11.1149Z" />
    </svg>
  )
}
